export class Score {
    homeScore: number;
    awayScore: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/score.model.ts